import React from 'react';
import { createRoot } from 'react-dom/client';
import './styles/main.scss';
import App from './App';

// Punto de entrada de la aplicación: monta App dentro del <div id="root"> de
// public/index.html.
const root = createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
